(($: JQueryStatic): void => {
    $.validator.addMethod("masked-input", (value: string, element: HTMLElement) => {
        if(!value) {
            return true;
        }

        const isValid = $(element).inputmask("isComplete");

        return isValid;
    });
    $.validator.unobtrusive.adapters.addBool("masked-input");
})(jQuery);
